import { Button, Modal } from "antd";
import { getUserInfo } from "../../utils/utils";

const DeactivateUser = ({
  isOpen,
  handleCancel,
  user,
  isDelete,
  selectedUsers,
  handleAction,
  isLoading,
}) => {
  const { id: userId } = getUserInfo();
  const safeSelected = selectedUsers || [];
  const isAdminAlsoSelected = !!safeSelected.find((d) => d?.id === userId);
  const effectiveSelected = safeSelected.filter((i) => i?.id !== userId);
  const selectedUsersCount = effectiveSelected.length;
  const selectedActive = effectiveSelected.filter((d) => d?.active);
  const selectedInactive = effectiveSelected.filter((d) => !d?.active);
  const alreadyInActive = selectedInactive.length;
  const needToInactive = selectedUsersCount - alreadyInActive;
  const isAllInactive =
    !user && selectedUsersCount === alreadyInActive && !isDelete;
  const isBulk = !user && selectedUsersCount > 0;
  const isBulkActivate =
    !isDelete &&
    isBulk &&
    selectedActive.length === 0 &&
    selectedInactive.length > 0;
  const isBulkDeactivate = !isDelete && isBulk && !isBulkActivate;
  const actionVerb = isDelete
    ? "Delete"
    : user
      ? user?.active
        ? "Deactivate"
        : "Activate"
      : isBulkActivate
        ? "Activate"
        : "Deactivate";
  const titleText = isDelete
    ? isBulk
      ? "Delete Selected Users"
      : "Delete Selected User"
    : actionVerb === "Activate"
      ? isBulk
        ? "Activate Selected Users"
        : "Activate Selected User"
      : isBulk
        ? "Deactivate Selected Users"
        : "Deactivate Selected User";

  const getInitials = (u) => {
    const first = u?.firstName?.trim()?.[0] || "";
    const last = u?.lastName?.trim()?.[0] || "";
    return `${first}${last}`.toUpperCase();
  };

  const renderUserRow = (u) => (
    <div
      key={u?.id || `${u?.firstName}-${u?.lastName}`}
      className="tw-flex tw-items-center tw-gap-2"
    >
      <div className="tw-size-[26px] tw-rounded-full tw-border tw-border-solid tw-border-border-secondary tw-flex tw-items-center tw-justify-center tw-text-[8px] tw-font-bold tw-text-text-primary tw-bg-white">
        {getInitials(u) || "U"}
      </div>
      <div className="tw-text-sm tw-text-text-primary">
        {u?.firstName} {u?.lastName}
      </div>
    </div>
  );

  return (
    <Modal
      title={null}
      className="delete-popup tw-overflow-hidden"
      open={isOpen}
      centered
      footer={null}
      onOk={handleCancel}
      onCancel={handleCancel}
    >
      <div className="tw-bg-slate-50 tw-text-slate-800 tw-text-lg tw-font-bold tw-py-4 tw-px-6 tw-rounded-t-2xl tw-border tw-border-solid tw-border-slate-100/50 tw-font-inter">
        {titleText}
      </div>
      <div className="tw-px-6 tw-py-5 tw-flex tw-flex-col tw-gap-3">
        {isAdminAlsoSelected && !selectedUsersCount && !user && (
          <div className="tw-text-xs tw-text-sub-text tw-bg-[#FFF7E6] tw-border tw-border-[#FFE0B3] tw-rounded-md tw-px-3 tw-py-2">
            The admin user cannot be {isDelete ? "deleted" : "deactivated"}.
          </div>
        )}

        {isDelete && (isBulk || user) && (
          <>
            {isAdminAlsoSelected && isBulk && (
              <div className="tw-text-xs tw-text-sub-text tw-bg-[#FFF7E6] tw-border tw-border-[#FFE0B3] tw-rounded-md tw-px-3 tw-py-2">
                The admin user cannot be deleted and won't be affected.
              </div>
            )}
            <div className="tw-bg-[#FFF2F2] tw-border tw-border-solid tw-border-[#E53B1D] tw-rounded-lg tw-p-3">
              <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-mb-2">
                Users To Be Deleted ({isBulk ? selectedUsersCount : 1}):
              </div>
              <div className="tw-grid tw-grid-cols-1 tw-gap-1.5 tw-text-xs tw-text-[#4C4C4C]">
                {isBulk
                  ? effectiveSelected.map(renderUserRow)
                  : renderUserRow(user)}
              </div>
            </div>
            <div className="tw-text-sm tw-text-sub-text">
              Are you sure you want to permanently delete the selected users?
              This action cannot be undone.
            </div>
          </>
        )}

        {!isDelete && isBulkActivate && (
          <>
            {isAdminAlsoSelected && (
              <div className="tw-text-xs tw-text-[#8A6D3B] tw-bg-[#FFF7E6] tw-border tw-border-[#FFE0B3] tw-rounded-md tw-px-3 tw-py-2">
                The admin user cannot be activated and won't be affected.
              </div>
            )}
            {selectedActive.length > 0 && (
              <div className="tw-bg-[#F7F7F7] tw-border tw-border-[#E6E6E6] tw-rounded-lg tw-p-3">
                <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-mb-2">
                  Already Active ({selectedActive.length}):
                </div>
                <div className="tw-grid tw-grid-cols-1 tw-gap-1.5 tw-text-xs tw-text-[#4C4C4C]">
                  {selectedActive.map(renderUserRow)}
                </div>
              </div>
            )}
            <div className="tw-bg-[#F7F7F7] tw-border tw-border-[#E6E6E6] tw-rounded-lg tw-p-3">
              <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-mb-3">
                Inactive Users To Be Activated ({selectedInactive.length}):
              </div>
              <div className="tw-grid tw-grid-cols-1 tw-gap-1.5 tw-text-xs tw-text-[#4C4C4C]">
                {selectedInactive.map(renderUserRow)}
              </div>
            </div>
            <div className="tw-text-sm tw-text-sub-text">
              Do you want to activate the selected{" "}
              {selectedInactive.length === 1 ? "user" : "users"}?
            </div>
          </>
        )}

        {!isDelete && isBulkDeactivate && (
          <>
            {isAdminAlsoSelected && (
              <div className="tw-text-xs tw-text-[#8A6D3B] tw-bg-[#FFF7E6] tw-border tw-border-[#FFE0B3] tw-rounded-md tw-px-3 tw-py-2">
                The admin user cannot be deactivated and won't be affected.
              </div>
            )}
            {selectedActive.length > 0 && (
              <div className="tw-bg-secondary-color tw-border tw-border-secondary-color tw-rounded-lg tw-p-3">
                <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-mb-3">
                  Active Users To Be Deactivated ({selectedActive.length}):
                </div>
                <div className="tw-grid tw-grid-cols-1 tw-gap-1.5 tw-text-xs tw-text-[#4C4C4C]">
                  {selectedActive.map(renderUserRow)}
                </div>
              </div>
            )}
            {selectedInactive.length > 0 && (
              <div className="tw-bg-[#F7F7F7] tw-border tw-border-[#E6E6E6] tw-rounded-lg tw-p-3">
                <div className="tw-text-sm tw-font-semibold tw-text-text-primary tw-mb-2">
                  Already Inactive ({selectedInactive.length}):
                </div>
                <div className="tw-grid tw-grid-cols-1 tw-gap-1.5 tw-text-xs tw-text-[#4C4C4C]">
                  {selectedInactive.map(renderUserRow)}
                </div>
              </div>
            )}
            {isAllInactive ? (
              <div className="tw-text-xs tw-text-[#4F4F4F]">
                Selected users are already inactive. Please review your
                selection.
              </div>
            ) : (
              <div className="tw-text-sm tw-text-sub-text">
                Do you want to deactivate the remaining {needToInactive}{" "}
                {needToInactive === 1 ? "user" : "users"}?
              </div>
            )}
          </>
        )}

        {!isDelete && user && (
          <>
            <div className="tw-bg-[#F7F7F7] tw-border tw-border-[#E6E6E6] tw-rounded-lg tw-p-3">
              <div className="tw-text-xs tw-font-semibold tw-text-[#3A3A3A] tw-mb-2">
                {user?.active ? "Active User" : "Inactive User"}:
              </div>
              <div className="tw-grid tw-grid-cols-1 tw-gap-1.5 tw-text-xs tw-text-[#4C4C4C]">
                {renderUserRow(user)}
              </div>
            </div>
            <div className="tw-text-sm tw-text-sub-text">
              {user?.active
                ? `Are you sure you want to deactivate ${user?.firstName} ${user?.lastName}? They will no longer be able to access the system.`
                : `Are you sure you want to activate ${user?.firstName} ${user?.lastName}? They will regain access to the system.`}
            </div>
          </>
        )}
      </div>
      <div className="tw-flex tw-bg-slate-50 tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-3 tw-border tw-border-solid tw-border-slate-100/50">
        <Button
          className="!tw-h-[38px] !tw-rounded-lg !tw-border-slate-200 !tw-bg-white !tw-px-5 !tw-text-xs !tw-font-bold !tw-text-slate-500 hover:!tw-border-slate-300 hover:!tw-text-slate-700 tw-transition-all tw-duration-200"
          onClick={handleCancel}
        >
          Cancel
        </Button>

        {(!!selectedUsersCount || !!user) && (
          <>
            {!(isBulkDeactivate && isAllInactive) && (
              <Button
                type="primary"
                disabled={isLoading}
                className={`!tw-h-[38px] !tw-rounded-lg !tw-text-white tw-text-xs tw-font-bold tw-px-5 tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200 ${
                  isDelete
                    ? "!tw-bg-red-600 !tw-border-red-600 hover:!tw-bg-red-700 hover:!tw-border-red-700"
                    : actionVerb === "Activate"
                      ? "!tw-bg-[#15C02F] !tw-border-[#15C02F] hover:!tw-bg-[#12a127] hover:!tw-border-[#12a127]"
                      : "!tw-bg-amber-600 !tw-border-amber-600 hover:!tw-bg-amber-700 hover:!tw-border-amber-700"
                }`}
                onClick={() => {
                  handleCancel();
                  handleAction();
                }}
              >
                {actionVerb === "Activate"
                  ? "Confirm Activation"
                  : actionVerb === "Deactivate"
                    ? "Confirm Deactivation"
                    : actionVerb}
              </Button>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default DeactivateUser;
